import { StyledHeader } from '@/shared/styles';
import styled from 'styled-components';

export const StyledLoggedInHeader = styled(StyledHeader)`
  display: flex;
  flex-direcrtion: row;
  justify-content: space-between;
`;
